import { computed, observable } from 'mobx';
import { WaterOutDto } from '../../api/generated';

import { IDiaryPageItem } from '../DiaryPageItem';

export class WaterDiaryPageItem implements IDiaryPageItem {

    public readonly type = 'water';

    @observable private _loading: boolean = false;

    private readonly _water: WaterOutDto;

    constructor(water: WaterOutDto) {
      this._water = water;
    }

    @computed get id() {
      return this._water.id!;
    }

    @computed get loading() {
      return this._loading;
    }

    @computed public get description() {
      return this._water.description;
    }

    @computed public get date() {
      return this._water.zonedTimestamp;
    }

    @computed public get hasThumbnail() {
      return false;
    }

  }


// WEBPACK FOOTER //
// ./src/diary/water/WaterDiaryPageItem.ts